import _request from "../common/_request";

let lib_website = {
    //活动排期
    plan: function (callback) {

        _request._get('/website/plan', null, function (response) {
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },
    // 亮点爆品等
    ui: function (tid, size, callback) {
        let data = {};
        data.tid = tid;
        data.size = size;

        _request._get('/website/ui', data, function (response) {
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },
    // news咨询 fenye
    news: function (tid, page, size, callback) {
        let data = {};
        data.tid = tid;
        data.page = page;
        data.size = size;

        _request._get('/website/news', data, function (response) {
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },

    // 阅读
    read: function (id, callback) {
        let data = {};
        data.id = id;
        console.log(data)

        _request._get('/website/read', data,function (response) {
            console.log(response)
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },



    //活动相关内容
    expo: function (callback) {

        _request._get('/website/expo', null, function (response) {
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },

    // 报名领票
    clue: function (expo_id, phone, name, callback) {
        let data = {}
        data.expo_id = expo_id
        data.phone = phone
        data.name = name
        console.log(data)
        _request._post('/website/clue', data, function (response) {
            console.log(response, '返回')
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },

    //参展入驻
    exhibitor: function (phone, name, industry,callback) {
        let data = {}
        data.phone = phone
        data.name = name
        data.industry = industry
        console.log(data, '入参')
        _request._post('/website/exhibitor', data, function (response) {
            console.log(response, '返回')
            if (response.code !== _request.success) {
                return;
            }
            //回调数据
            callback(response.data)
        })
    },


};
export default lib_website
